export const PRIMARY_BLUE = "#2BAEF9";
export const NEUTRAL_300 = "#E4E8EE";
export const NEUTRAL_500 = "#A8B1BD";
export const NEUTRAL_700 = "#49505A";
export const WHITE = "#FFFFFF";
export const BLACK = "#000000";
export const DARK_BLUE = "#1F3049";
